<template>
    <div ref="root">
        <div
            class="imagetext__container module__container"
            v-bind:class="{
                container__fluid: [1, 2, 3, 4].includes(module.layout.type),
                container__boxed: [5, 6].includes(module.layout.type)
            }"
        >
            <div
                class="imagetext__inner module__inner"
                v-bind:class="{ 'module__inner--two-cols': [5, 6].includes(module.layout.type) }"
            >
                <div
                    class="imagetext__inner--main module__inner--main"
                    v-if="
                        ((module.data.title ||
                            module.data.subtitle ||
                            module.data.text ||
                            (module.data.link && module.data.link.active) ||
                            (module.data.link2 && module.data.link2.active) ||
                            (module.data.link3 && module.data.link3.active)) &&
                            [3, 4].includes(module.layout.type)) ||
                            [1, 2, 5, 6].includes(module.layout.type)
                    "
                    v-bind:class="{
                        'calc-padding--left': [1].includes(module.layout.type),
                        'calc-padding--right': [2].includes(module.layout.type),
                        'bg-color': [3, 4].includes(module.layout.type)
                    }"
                >
                    <div
                        class="imagetext__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle"
                    >
                        <div class="imagetext__inner-col module__inner-col">
                            <div class="imagetext__header module__header">
                                <h2
                                    class="imagetext__title module__title font-h2 color-h2"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="imagetext__subtitle module__subtitle font-h3 color-h3"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                            </div>
                        </div>
                    </div>
                    <div class="imagetext__inner-row module__inner-row" v-if="module.data.text">
                        <div class="imagetext__inner-col module__inner-col">
                            <div
                                class="imagetext__text module__text font-p color-p module__cms"
                                v-if="module.data.text"
                                v-html="module.data.text"
                            ></div>
                        </div>
                    </div>
                    <div
                        class="imagetext__inner-row module__inner-row"
                        v-if="
                            (module.data.link && module.data.link.active) ||
                                (module.data.link2 && module.data.link2.active) ||
                                (module.data.link3 && module.data.link3.active)
                        "
                    >
                        <div class="imagetext__inner-col module__inner-col">
                            <div class="imagetext__cta module__cta">
                                <app-modulebutton
                                    :data="module.data.link"
                                    :custom-class="
                                        'imagetext__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    :data="module.data.link2"
                                    :custom-class="
                                        'imagetext__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    :data="module.data.link3"
                                    :custom-class="
                                        'imagetext__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="imagetext__inner--image module__inner--image"
                    v-if="
                        [1, 2, 3, 4, 5, 6].includes(module.layout.type) &&
                            module.data.image &&
                            module.data.image.id
                    "
                >
                    <app-moduleimage
                        v-if="[1, 2, 3, 4, 5, 6].includes(module.layout.type)"
                        :data="module.data.image"
                        :tag="'div'"
                        :custom-class="'imagetext__moduleimage module__moduleimage'"
                    >
                    </app-moduleimage>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleButton from '@/components/assorted/ModuleButton';

export default {
    data() {
        return {};
    },
    components: {
        'app-moduleimage': ModuleImage,
        'app-modulebutton': ModuleButton
    },
    methods: {},
    computed: {},
    props: {
        module: Object
    },
    mounted() {}
};
</script>
